import { useState, FC, useCallback } from 'react';
import styles from '../NavBar.module.scss';
import { Link as LinkRoll } from 'react-scroll';
import { useNavigate, useLocation } from 'react-router-dom';

const SandwichNavBar: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  const navigateToHome = useCallback(() => {
    const path = location.pathname;

    if (path !== '/') {
      navigate('/');
    }

    setMenuOpen(false);
  }, [location.pathname, navigate]);

  const handleCheckboxChange = () => setMenuOpen(prev => !prev);

  return (
    <header className={styles['site-nav']}>
      <div className={styles.brand}>
        <span className={styles.name}>Jose Cerejo</span>
        <span className={styles.role}>Frontend / Software Engineering</span>
      </div>

      <button
        className={styles['menu-toggle']}
        onClick={handleCheckboxChange}
        aria-expanded={menuOpen}
        aria-controls="primary-navigation"
      >
        <span></span>
        <span></span>
      </button>

      <nav id="primary-navigation" className={`${styles.navigation} ${menuOpen ? styles.open : ''}`}>
        <ul>
          <li>
            <LinkRoll
              activeClass={styles.active}
              to="home"
              spy={true}
              smooth={true}
              offset={0}
              duration={500}
              onClick={navigateToHome}
            >
              Home
            </LinkRoll>
          </li>
          <li>
            <LinkRoll
              activeClass={styles.active}
              to="about"
              spy={true}
              smooth={true}
              offset={-60}
              duration={500}
              onClick={navigateToHome}
            >
              About
            </LinkRoll>
          </li>
          <li>
            <LinkRoll
              activeClass={styles.active}
              to="projects"
              spy={true}
              smooth={true}
              offset={-60}
              duration={500}
              onClick={navigateToHome}
            >
              Projects
            </LinkRoll>
          </li>
          <li>
            <LinkRoll
              activeClass={styles.active}
              to="experience"
              spy={true}
              smooth={true}
              offset={-60}
              duration={500}
              onClick={navigateToHome}
            >
              Experience
            </LinkRoll>
          </li>
          <li>
            <LinkRoll
              activeClass={styles.active}
              to="skills"
              spy={true}
              smooth={true}
              offset={-60}
              duration={500}
              onClick={navigateToHome}
            >
              Skills
            </LinkRoll>
          </li>
          <li>
            <LinkRoll
              activeClass={styles.active}
              to="contact"
              spy={true}
              smooth={true}
              offset={-60}
              duration={500}
              onClick={navigateToHome}
            >
              Contact
            </LinkRoll>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default SandwichNavBar;
